module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/~/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = 9